import { makeStyles } from '@material-ui/core/styles';
import { mergeStyles } from './stylesSelector';
import { cloneDeep } from 'lodash';
import { CONTENT_MIN_WIDTH, styleBreakDesktop, styleBreakMobile } from '../components/utilities/layouts/Globals';
import { COLOR_WHITE } from '../components/utilities/MaterialWatchman';

// This function will merge custom overrides.
export const TutorialPageStyle = stylesOverride => {
    return makeStyles(theme => {
        const defaultstyles = {
            root: {
                justifyContent: 'space-around',
                display: 'grid',
                textAlign: 'center',
                overflow: 'hidden',
                [styleBreakMobile(theme)]: {
                    paddingTop: theme.spacing(4),
                    flexDirection: 'column',
                },
            },
            body: {
                maxWidth: theme.spacing(55),
                paddingTop: theme.spacing(11.5),
                paddingBottom: theme.spacing(6),
                [styleBreakMobile(theme)]: {
                    paddingTop: theme.spacing(3),
                    paddingBottom: theme.spacing(11.5),
                    maxWidth: theme.spacing(40),
                },
                [styleBreakDesktop(theme)]: {
                    overflowY: 'scroll',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                },
            },
            button: {
                width: 'fit-content',
                minWidth: theme.spacing(47.5),
                [styleBreakMobile(theme)]: {
                    position: 'fixed',
                    marginBottom: theme.spacing(3),
                    marginTop: theme.spacing(0),
                    bottom: '0',
                    minWidth: CONTENT_MIN_WIDTH,
                    width: 'calc(100% - 48px)',
                    left: '50%',
                    transform: 'translateX(-50%)',
                },
                [styleBreakDesktop(theme)]: {
                    margin: theme.spacing(0),
                    top: '50%',
                    left: '50%',
                    transform: `translate(${-50}%, ${-50}%)`,
                },
            },
            subtitle: {
                marginTop: theme.spacing(4),
                [styleBreakMobile(theme)]: {
                    maxWidth: theme.spacing(33),
                    marginLeft: theme.spacing(3.5),
                    marginRight: theme.spacing(3.5),
                },
            },
            bodyText: {
                marginTop: theme.spacing(1),
                [styleBreakMobile(theme)]: {
                    padding: `${theme.spacing(0)}px ${theme.spacing(1)}px ${theme.spacing(0)}px ${theme.spacing(1)}px`,
                },
            },
            contentLayoutDiv: {
                height: 'calc(100vh - 80px)',
                width: '100%',
                alignItems: 'center',
                overflow: 'hidden',
                [styleBreakMobile(theme)]: {
                    height: '100%',
                },
                [styleBreakDesktop(theme)]: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                },
            },
            icon: {
                width: theme.spacing(35),
                height: theme.spacing(35),
                marginLeft: -theme.spacing(4),
                '& circle.circleClass': {
                    fill: COLOR_WHITE,
                },
                [styleBreakMobile(theme)]: {
                    width: theme.spacing(25),
                    height: theme.spacing(25),
                    marginLeft: -theme.spacing(2),
                },
            },
        };

        // overrides the default
        return mergeStyles(cloneDeep(defaultstyles), stylesOverride || {});
    });
};
